import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import Legends from '../../../../../../components/NovoSistema/Legends';

export default function CadastroDeClienteSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Código" id="Codigo" widthPercentage="20%" />
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={['', 'Ativa', 'Inativa']}
            widthPercentage="20%"
          />
          <SelectAndOptions
            title="Tipo de Pessoa"
            id="TipoDePessoa"
            optionsArray={['', 'Física', 'Jurídica']}
            widthPercentage="20%"
          />
          <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Nome / Razão Social" id="NomeRazaoSocial" widthPercentage="40%" />
          <InputText title="Apelido / Nome Fantasia" id="ApelidoNomeFantasia" widthPercentage="40%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="* UF"
            id="UF"
            optionsArray={[
              '',
              'AC',
              'AL',
              'AP',
              'AM',
              'BA',
              'CE',
              'DF',
              'ES',
              'GO',
              'MA',
              'MT',
              'MS',
              'MG',
              'PA',
              'PB',
              'PR',
              'PE',
              'PI',
              'RJ',
              'RN',
              'RS',
              'RO',
              'RR',
              'SC',
              'SP',
              'SE',
              'TO',
            ]}
            widthPercentage="20%"
          />
          <SelectAndOptions title="Município" id="Municipio" optionsArray={['']} widthPercentage="20%" />
          <SelectAndOptions
            title="Tipo de Cadastro"
            id="TipoDeCadastro"
            optionsArray={['', 'Cliente', 'Fornecedor', 'Fabricante', 'Transportadora', 'Outros']}
            widthPercentage="20%"
          />
          <InputDate title="Cadastrado a partir de" id="CadastradoAPartirDe" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <ContainerSection>
          <h3>Outros Filtros</h3>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title=""
              id="OutrosFiltros"
              optionsArray={['', 'Área', 'Grupo', 'Matricula', 'Valor Contribuição', 'Parentesco']}
              widthPercentage="20%"
            />
          </WrapperInputsNewSystem>
        </ContainerSection>
        <ButtonsSearch />
      </ContainerSection>
      <ContainerSection>
        <h3>Legenda</h3>
        <Legends
          itens={[
            { text: 'Ativo', color: 'green' },
            { text: 'Inativo', color: 'red' },
          ]}
        />
      </ContainerSection>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
